import { render, staticRenderFns } from "./change-record.vue?vue&type=template&id=b3366970&scoped=true"
import script from "./change-record.vue?vue&type=script&lang=js"
export * from "./change-record.vue?vue&type=script&lang=js"
import style0 from "./change-record.vue?vue&type=style&index=0&id=b3366970&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3366970",
  null
  
)

export default component.exports